import ApiClient from "./ApiClient";
import { ApiResponse } from "./ApiResponse";




export async function getApi<R>(
  endpoint: string,
  params?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.get<ApiResponse<R>>(endpoint, { params });
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}


/* ===========================
   GET BY ID
=========================== */
export async function getApiById<R>(
  endpoint: string,
  resourceId: string,
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.get<ApiResponse<R>>(`${endpoint}/${resourceId}`);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   GET BY ID
=========================== */
export async function getApiByWithoutId<R>(
  endpoint: string,
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.get<ApiResponse<R>>(`${endpoint}`);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   GET BY ID
=========================== */
export async function getApiListById<R>(
  endpoint: string,
  resourceId: string,
  params?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.get<ApiResponse<R>>(`${endpoint}/${resourceId}`, { params });
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   GET BY ID
=========================== */
export async function getApiListWithoutId<R>(
  endpoint: string,
  params?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.get<ApiResponse<R>>(`${endpoint}`, { params });
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   POST
=========================== */
export async function postApi<R>(
  endpoint: string,
  payload: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.post<ApiResponse<R>>(endpoint, payload);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   POST WITOUT BODY
=========================== */

export async function postApiWithoutBody<R>(
  endpoint: string
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.post<ApiResponse<R>>(endpoint);
    return res.data;
  } catch (err: any) {
    return (
      err.response?.data || {
        success: false,
        message: "Something went wrong",
        data: null,
      }
    );
  }
}

/* ===========================
   POST WIth Pagination
=========================== */
export async function postApiPagination<R>(
  endpoint: string,
  payload: any,
  params?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.post<ApiResponse<R>>(endpoint, payload, { params });
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}


/* ===========================
   POST WITH PATH PARAM
=========================== */
export async function postApiByPathParam<R>(
  endpoint: string
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.post<ApiResponse<R>>(endpoint);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   PUT
=========================== */
/* ===========================
   PATCH
   =========================== */

export async function patchApi<R>(
  endpoint: string,
  resourceId: string,
  payload?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.patch<ApiResponse<R>>(`${endpoint}/${resourceId}`, payload);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   PUT
   =========================== */

export async function putApi<R>(
  endpoint: string,
  resourceId: string,
  payload?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.put<ApiResponse<R>>(`${endpoint}/${resourceId}`, payload);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}


/* ===========================
   PUT
=========================== */
export async function putApiWithoutId<R>(
  endpoint: string,
  payload?: any
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.put<ApiResponse<R>>(`${endpoint}`, payload);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}

/* ===========================
   DELETE
=========================== */
export async function deleteApi<R = null>(
  endpoint: string,
  resourceId: string,
): Promise<ApiResponse<R>> {
  try {
    const res = await ApiClient.delete<ApiResponse<R>>(`${endpoint}/${resourceId}`);
    return res.data;
  } catch (err: any) {
    return err.response?.data || {
      success: false,
      message: "Something went wrong",
      data: null,
    };
  }
}
